import { useContext } from 'react';

import SingleCaseContext from './SingleCaseContext';

const useSingleCase = () => {
  const context = useContext(SingleCaseContext);
  if (context === null) {
    throw new Error('useSingleCase must be used within a SingleCaseProvider');
  }
  return context;
};

export default useSingleCase;
